import React from "react";
import { getOrderTypeLabel } from "../../../utils/marketplaceHelpers";
import { netural400 } from "../../../constants/color";

const TransferOrderTypeChip = ({ orderType }) => {
  const label = getOrderTypeLabel(orderType);

  return (
    <span
      style={{
        fontSize: "14px",
        color: netural400,
      }}
    >
      {label}
    </span>
  );
};

export default TransferOrderTypeChip;
